import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../../../components/Navbar';
import DragupButton from '../../../components/DragupButton';
import Footer from '../../../components/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import imgInst from '../../../images/P10.webp';
import { faTools, faFileAlt, faCogs, faBroom } from '@fortawesome/free-solid-svg-icons';
import './Installation.css';

function Installation() {
  return (
    <>
      <Helmet>
        <title>Installation | Elektro Thome</title>
        <link rel="canonical" href="https://energy-thome.com/leistungen/installation" />
      </Helmet>
      <DragupButton />
      <Navbar />

      {/* Main Content */}
      <div className="installation-container">
        {/* Hero Section */}
        <section className="installation-hero-section">
          <div className="installation-hero-text">
            <h1>Haus Installation</h1>
            <p>
              Sie planen ein neues Zuhause? Wir bieten umfassende Unterstützung
              bei der Elektroinstallation – von der ersten Planung bis zur
              Abnahme. Unser Team sorgt für eine sichere, zukunftssichere und
              effiziente Umsetzung, die perfekt auf Ihre Bedürfnisse
              zugeschnitten ist. Vertrauen Sie auf unsere Expertise für eine
              reibungslose Installation, damit Ihr Bauprojekt stressfrei gelingt.
            </p>
            <Link to="/contact" className="installation-cta-button">
              Kontaktieren Sie uns für eine Beratung
            </Link>
          </div>
          <div className="installation-hero-image">
            <img
              src={imgInst}
              alt="Haus Elektroinstallation"
            />
          </div>
        </section>

        {/* Services Section */}
        <section className="installation-services-section">
          <h2>Unsere Leistungen für Ihre Hausinstallation</h2>
          <div className="installation-services-grid">
            <div className="installation-service-box">
              <FontAwesomeIcon icon={faFileAlt} className="installation-service-icon" />
              <h3>Planung</h3>
              <p>
                Professionelle Planung Ihrer Elektroinstallation, abgestimmt auf
                Ihre individuellen Bedürfnisse und Bauvorgaben.
              </p>
            </div>
            <div className="installation-service-box">
              <FontAwesomeIcon icon={faTools} className="installation-service-icon" />
              <h3>Montage</h3>
              <p>
                Fachgerechte Montage von Elektroinstallationen, inklusive
                Sicherheitsprüfungen und Anschlussarbeiten.
              </p>
            </div>
            <div className="installation-service-box">
              <FontAwesomeIcon icon={faCogs} className="installation-service-icon" />
              <h3>Wartung</h3>
              <p>
                Regelmäßige Wartung und Überprüfung Ihrer elektrischen Anlagen,
                um Sicherheit und Effizienz zu gewährleisten.
              </p>
            </div>
            <div className="installation-service-box">
              <FontAwesomeIcon icon={faBroom} className="installation-service-icon" />
              <h3>Reinigung</h3>
              <p>
                Gründliche Reinigung und Pflege Ihrer Elektroinstallationen für
                maximale Langlebigkeit und Funktionalität.
              </p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default Installation;
